import { BforLogoIcon } from '../assets/BforLogoIcon';
import { BitPandaLogoIcon } from '../assets/BitPandaLogoIcon';
import { BwBankLogoIcon } from '../assets/BwBankLogoIcon';
import {
  MoneliqInvertedLogoIcon,
  MoneliqLogoIcon,
} from '../assets/MoneliqLogoIcon';
import { RakbankLogoIcon } from '../assets/RakbankLogoIcon';
import {
  SgforgeInvertedLogoIcon,
  SgforgeLogoIcon,
} from '../assets/SgforgeLogoIcon';
import { AppConfig, OnboardingQuestionnaireType } from './types';

export const PROD_CONFIGS: AppConfig[] = [
  {
    appId: 1,
    appLogo: BitPandaLogoIcon,
    appName: 'Raiffeisen',
    tenantTranslationKeySuffix: 'raiffeisen',
    welcomeContinueButtonVisual: 'secondary',
    welcomeScreenBadgesVisual: 'filledNeutralDark',
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/de/academy',
    classicOnboardingSuccessfulMessageType: 'withoutRiskDisclosure',
    currency: 'EUR',
    landingPageLangIconColorScheme: 'dark', //TODO: change this to light after onboarding background token is fixed
    minimumFiatTradeAmountForSingleCurrency: 1,
    minimumSavingsAmount: 10,
    minimumCalendarDaysBeforeExecution: 4,
    paymentDaysBeforeExecution: 3,
    maxDaysFromMonthEndForSavingsExecution: 2,
    onboardingType: OnboardingQuestionnaireType.CLASSIC,
    partnerHostAppName: 'Mein ELBA-App',
    supportedLanguages: ['de', 'en'],
    improvedAuthFlow: true,
  },
  {
    additionalBuyConfirmationText: 'lbbw_buy_success_info',
    additionalSellConfirmationText: 'lbbw_sell_success_info',
    appId: 2,
    appLogo: BitPandaLogoIcon,
    appName: 'LBBW',
    tenantTranslationKeySuffix: 'lbbw',
    welcomeContinueButtonVisual: 'secondary',
    welcomeScreenBadgesVisual: 'filledNeutralDark',
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/en/academy',
    currency: 'EUR',
    landingPageLangIconColorScheme: 'dark', //TODO: change this to light after onboarding background token is fixed
    localPublicFolderPathTo_FAQDocument: '/LBBW-CryptoApp-FAQ-document.pdf',
    minimumFiatTradeAmountForSingleCurrency: 1,
    onboardingType: OnboardingQuestionnaireType.CORPORATE,
    URLforCustomerSupport:
      'https://lbbwsupport.bitpanda.com/hc/de/requests/new',
    supportedLanguages: ['en', 'de'],
    disableDac8: true,
    skipWelcomePage: true,
    useNativeTermsPreviewOnDesktop: true,
  },
  {
    appId: 3,
    appLogo: RakbankLogoIcon,
    appName: 'Rakbank',
    tenantTranslationKeySuffix: 'rakbank',
    welcomeContinueButtonVisual: 'secondary',
    welcomeScreenBadgesVisual: 'filledNeutralDark',
    arePdfsOpenedAsLinks: true,
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/en/academy',
    // TODO temporary until we are receiving it from BE
    islamicComplianceUrl: 'https://www.rakbank.ae/en/islamic/personal',
    classicOnboardingSuccessfulMessageType: 'withRiskDisclosure',
    currency: 'AED',
    disableLogoutButton: true,
    // TODO turn it on when Rakbank is ready
    useLegacyOperationUrls: true,
    // TODO temporary until we are receiving user residency
    isUAETenant: true,
    landingPageLangIconColorScheme: 'dark',
    minimumFiatTradeAmountForSingleCurrency: 5,
    minimumSavingsAmount: 100,
    minimumCalendarDaysBeforeExecution: 2,
    paymentDaysBeforeExecution: 2,
    maxDaysFromMonthEndForSavingsExecution: 2,
    onboardingType: OnboardingQuestionnaireType.CLASSIC,
    partnerHostAppName: 'RAKBANK App',
    reportsTypeFilterItems: [
      'ALL',
      'ACCOUNT_STATEMENT',
      'TRADES_VALUE_ADDED_TAX',
    ],
    supportedLanguages: ['ar', 'en'],
    savingsPlansFrequencySelection: ['WEEKLY', 'BIWEEKLY', 'MONTHLY'], // DAILY ONLY FOR REPLICA FOR NOW
    disableDac8: true,
  },
  {
    appId: 4,
    appLogo: SgforgeLogoIcon,
    appLogoInverted: SgforgeInvertedLogoIcon,
    appName: 'SGForge',
    tenantTranslationKeySuffix: 'sgforge',
    welcomeContinueButtonVisual: 'primary',
    welcomeScreenBadgesVisual: 'filledNeutralDark',
    onboardingSuccessfulInfoLayoutVariant: 'dark',
    infoLayoutColorScheme: 'brand',
    infoLayoutTextVariant: 'inverted',
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/en/academy',
    currency: 'EUR',
    isByol: true,
    landingPageLangIconColorScheme: 'dark',
    minimumFiatTradeAmountForSingleCurrency: 1,
    onboardingType: OnboardingQuestionnaireType.CLASSIC,
    supportedLanguages: ['en'],
    disableDac8: true,
  },
  {
    appId: 5,
    appLogo: BitPandaLogoIcon,
    appName: 'Ribbon',
    tenantTranslationKeySuffix: 'ribbon',
    welcomeContinueButtonVisual: 'secondary',
    welcomeScreenBadgesVisual: 'filledNeutralDark',
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/de/academy',
    classicOnboardingSuccessfulMessageType: 'withoutRiskDisclosure',
    currency: 'GBP',
    landingPageLangIconColorScheme: 'dark', //TODO: change this to light after onboarding background token is fixed
    minimumFiatTradeAmountForSingleCurrency: 1,
    onboardingType: OnboardingQuestionnaireType.CLASSIC,
    partnerHostAppName: 'Ribbon App',
    supportedLanguages: ['de', 'en'],
  },
  {
    appId: 6,
    appLogo: BitPandaLogoIcon,
    appName: 'Raiffeisen Tirol',
    tenantTranslationKeySuffix: 'raiffeisen_tirol',
    welcomeContinueButtonVisual: 'secondary',
    welcomeScreenBadgesVisual: 'filledNeutralDark',
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/de/academy',
    classicOnboardingSuccessfulMessageType: 'withoutRiskDisclosure',
    currency: 'EUR',
    landingPageLangIconColorScheme: 'dark',
    minimumFiatTradeAmountForSingleCurrency: 1,
    minimumSavingsAmount: 10,
    minimumCalendarDaysBeforeExecution: 4,
    paymentDaysBeforeExecution: 3,
    maxDaysFromMonthEndForSavingsExecution: 2,
    onboardingType: OnboardingQuestionnaireType.CLASSIC,
    partnerHostAppName: 'Raiffeisen Tirol-App',
    supportedLanguages: ['de', 'en'],
  },
  {
    appId: 7,
    appLogo: BforLogoIcon,
    appName: 'BFOR',
    tenantTranslationKeySuffix: 'bfor',
    welcomeContinueButtonVisual: 'primary',
    welcomeScreenBadgesVisual: 'outlineNeutralDark',
    welcomeScreenInfoLayoutVariant: 'primary',
    onboardingSuccessfulInfoLayoutVariant: 'dark',
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/en/academy',
    classicOnboardingSuccessfulMessageType: 'withoutRiskDisclosure',
    currency: 'EUR',
    landingPageLangIconColorScheme: 'dark',
    minimumFiatTradeAmountForSingleCurrency: 1,
    minimumSavingsAmount: 10,
    minimumCalendarDaysBeforeExecution: 4,
    paymentDaysBeforeExecution: 3,
    maxDaysFromMonthEndForSavingsExecution: 2,
    onboardingType: OnboardingQuestionnaireType.CLASSIC,
    partnerHostAppName: 'BFOR App',
    supportedLanguages: ['en', 'fr'],
  },
  {
    appId: 8,
    appLogo: BitPandaLogoIcon,
    bankLogo: BwBankLogoIcon,
    appName: 'BW Bank',
    tenantTranslationKeySuffix: 'bw_bank',
    welcomeContinueButtonVisual: 'secondary',
    welcomeScreenBadgesVisual: 'filledNeutralDark',
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/en/academy',
    classicOnboardingSuccessfulMessageType: 'withoutRiskDisclosure',
    currency: 'EUR',
    landingPageLangIconColorScheme: 'dark',
    minimumFiatTradeAmountForSingleCurrency: 1,
    onboardingType: OnboardingQuestionnaireType.CLASSIC,
    partnerHostAppName: 'BW Bank-App',
    supportedLanguages: ['en', 'de'],
    settlementType: 'TYPE_3',
    automaticWithdrawalsDefaultEnabled: true,
    disableDac8: true,
    supportPhoneNumber: '0711 124-44466',
    supportEmail: 'kontakt@bw-bank.de',
    useNativeTermsPreviewOnDesktop: true,
  },
  {
    appId: 9,
    appLogo: BitPandaLogoIcon,
    appName: 'Raiffeisen Steiermark',
    tenantTranslationKeySuffix: 'raiffeisen_steiermark',
    welcomeContinueButtonVisual: 'secondary',
    welcomeScreenBadgesVisual: 'filledNeutralDark',
    classicOnboardingSuccessfulMessageType: 'withoutRiskDisclosure',
    currency: 'EUR',
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/de/academy',
    landingPageLangIconColorScheme: 'dark',
    minimumFiatTradeAmountForSingleCurrency: 1,
    onboardingType: OnboardingQuestionnaireType.CLASSIC,
    partnerHostAppName: 'Mein ELBA-App',
    supportedLanguages: ['de', 'en'],
  },
  {
    appId: 10,
    appLogo: BitPandaLogoIcon,
    appName: 'Raiffeisen Salzburg',
    tenantTranslationKeySuffix: 'raiffeisen_salzburg',
    welcomeContinueButtonVisual: 'secondary',
    welcomeScreenBadgesVisual: 'filledNeutralDark',
    classicOnboardingSuccessfulMessageType: 'withoutRiskDisclosure',
    currency: 'EUR',
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/de/academy',
    landingPageLangIconColorScheme: 'dark',
    minimumFiatTradeAmountForSingleCurrency: 1,
    minimumSavingsAmount: 10,
    minimumCalendarDaysBeforeExecution: 4,
    paymentDaysBeforeExecution: 3,
    maxDaysFromMonthEndForSavingsExecution: 2,
    onboardingType: OnboardingQuestionnaireType.CLASSIC,
    partnerHostAppName: 'Mein ELBA-App',
    supportedLanguages: ['de', 'en'],
  },
  {
    appId: 11,
    appLogo: BitPandaLogoIcon,
    appName: 'Raiffeisen Vorarlberg',
    tenantTranslationKeySuffix: 'raiffeisen_vorarlberg',
    welcomeContinueButtonVisual: 'secondary',
    welcomeScreenBadgesVisual: 'filledNeutralDark',
    classicOnboardingSuccessfulMessageType: 'withoutRiskDisclosure',
    currency: 'EUR',
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/de/academy',
    landingPageLangIconColorScheme: 'dark',
    minimumFiatTradeAmountForSingleCurrency: 1,
    minimumSavingsAmount: 10,
    minimumCalendarDaysBeforeExecution: 4,
    paymentDaysBeforeExecution: 3,
    maxDaysFromMonthEndForSavingsExecution: 2,
    onboardingType: OnboardingQuestionnaireType.CLASSIC,
    partnerHostAppName: 'Mein ELBA-App',
    supportedLanguages: ['de', 'en'],
  },
  {
    appId: 12,
    appLogo: BitPandaLogoIcon,
    appName: 'iCard',
    tenantTranslationKeySuffix: 'icard',
    welcomeContinueButtonVisual: 'secondary',
    welcomeScreenBadgesVisual: 'filledNeutralDark',
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/en/academy',
    classicOnboardingSuccessfulMessageType: 'withoutRiskDisclosure',
    currency: 'EUR',
    landingPageLangIconColorScheme: 'dark',
    minimumFiatTradeAmountForSingleCurrency: 1,
    onboardingType: OnboardingQuestionnaireType.CLASSIC,
    partnerHostAppName: 'iCard App',
    supportedLanguages: ['en', 'it', 'fr', 'de'],
  },
  {
    appId: 13,
    appLogo: MoneliqLogoIcon,
    appLogoInverted: MoneliqInvertedLogoIcon,
    appLogoSize: 85,
    infoLayoutColorScheme: 'brand',
    infoLayoutTextVariant: 'inverted',
    appName: 'Moneliq',
    tenantTranslationKeySuffix: 'moneliq',
    welcomeContinueButtonVisual: 'secondary',
    welcomeScreenBadgesVisual: 'filledNeutralDark',
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/en/academy',
    classicOnboardingSuccessfulMessageType: 'withoutRiskDisclosure',
    currency: 'GBP',
    landingPageLangIconColorScheme: 'dark',
    minimumFiatTradeAmountForSingleCurrency: 1,
    onboardingType: OnboardingQuestionnaireType.CLASSIC,
    partnerHostAppName: 'Moneliq App',
    supportedLanguages: ['en'],
    settlementType: 'TYPE_2',
  },
  {
    appId: 14,
    appLogo: BitPandaLogoIcon,
    appName: 'Raiffeisen Oberosterreich',
    tenantTranslationKeySuffix: 'raiffeisen_ooe',
    welcomeContinueButtonVisual: 'secondary',
    welcomeScreenBadgesVisual: 'filledNeutralDark',
    classicOnboardingSuccessfulMessageType: 'withoutRiskDisclosure',
    currency: 'EUR',
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/de/academy',
    landingPageLangIconColorScheme: 'dark',
    minimumFiatTradeAmountForSingleCurrency: 1,
    minimumSavingsAmount: 10,
    minimumCalendarDaysBeforeExecution: 4,
    paymentDaysBeforeExecution: 3,
    maxDaysFromMonthEndForSavingsExecution: 2,
    onboardingType: OnboardingQuestionnaireType.CLASSIC,
    partnerHostAppName: 'Mein ELBA-App',
    supportedLanguages: ['de', 'en'],
  },
];
